import { ObjectifFormationLibelle, TypeReferentielFormationLibelle } from '@/features/domaine/types/opco/Demande/AF'
import { objectToDropdownItems } from '@/features/interface/shared/tools'

export const objectifFormationItems = objectToDropdownItems(ObjectifFormationLibelle)
export const typeReferentielFormationItems = objectToDropdownItems(TypeReferentielFormationLibelle)
